$(document).ready(function(){

// $('.menu-item.has-megamenu a').hover(
//   function() {
//     // When hovered
//     $('body').css('overflow-y', 'hidden');
//     $('html').css('overflow-y', 'hidden');
//   },
//   function() {
//     // When hover ends
//     $('body').css('overflow-y', '');
//     $('html').css('overflow-y', '');
//   }
// );
  
// Banner Slider Section
$('.customslider-sectioninner').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: true,
  autoplay:true,
  autoplaySpeed: 3000, // 3 seconds delay between slides
  speed: 800  ,  
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
   
});

     
// Tabbing Slider Section


function initSlider(slider) {
  if (slider.hasClass("slick-initialized")) {
    return;
  }

  slider.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    speed: 600,
    prevArrow:
      '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Frame_1400010200.png?v=1760424613" alt="Icon" /></button>',
    nextArrow:
      '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Frame_1400010200.png?v=1760424613" alt="Icon" /></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.6,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.4,
          arrows: false
        }
      }
    ]
  });
}

// first visible slider init
$(document).ready(function () {
  var firstSlider = $(".productcontent-section:visible").find("ul");
  initSlider(firstSlider);
});

$(".tabbingbutton-section button").click(function () {
  var dataText = $(this).data("text");
  var dataHeading = $(this).data("heading");
  $(".subheading-section h3").text(dataHeading)
  $(".tabbingbutton-section button").removeClass("active");
  $(this).addClass("active");

  $(".productcontent-section").hide();
  var activeSection = $(`[data-value="${dataText}"]`);
  activeSection.show();

  var slider = activeSection.find("ul");

  if (slider.hasClass("slick-initialized")) {
    slider.slick("refresh");
  } else {
    initSlider(slider);
  }
});






// Product Grid Slider

$('.productslider-section ul').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  speed: 600,
  prevArrow:
    '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Frame_1400010200.png?v=1760424613" alt="Icon" /></button>',
  nextArrow:
    '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Frame_1400010200.png?v=1760424613" alt="Icon" /></button>',
    responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.6,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.4,
        slidesToScroll: 1,
        arrows: false,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



// Offer Code Copy On PDP Page

$(".copysec").click(function() {
    var copyText = $(this).attr("data-text");

    // Create a temporary input to copy text
    var tempInput = $("<input>");
    $("body").append(tempInput);
    tempInput.val(copyText).select();
    document.execCommand("copy");
    tempInput.remove();

    // Change text to "Copied!" for 2 seconds
    var btn = $(this);
    var originalText = btn.text();
    btn.text("Copied!");
    setTimeout(function(){
      btn.text(originalText);
    }, 2000);
  });



// Tips Image Click PDP  

$(".tipscontent-sec ul li").click(function(){
  var dataText = $(this).data("para");
  var dataHeading = $(this).data("heading");

  //$(".headingtxt b").text(dataHeading);
  $(".tipstext").text(dataText);
 
    $(".tipscontent-sec ul li").removeClass("active"); 
    $(this).addClass("active"); 
})

$(window).on("load", function(){
  $(".tipscontent-sec ul li.active").click()
})

// Accordion Click Function

$(".accordionheading, .faqheading-sec, .footer-block__heading, .category-heading").click(function(){
  if($(this).hasClass("active")){
    $(this).removeClass("active")
  }else{
    $(this).addClass("active")
  }
})

// Initialize slick
  $('.logo-box').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    pauseOnHover: true,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });

  $('.textmarquee-section').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 8000,              // controls smooth scrolling speed
      autoplay: true,
      autoplaySpeed: 0,         // VERY IMPORTANT for continuous scroll
      cssEase: 'linear',        // makes animation smooth (no easing)
      arrows: false,
      dots: false,
      pauseOnHover: false,
      variableWidth: true,      // allows content to flow naturally
      infinite: true
    });

  // Change text when logo clicked
  $('.logo-box').on('click', 'a', function(e){
    e.preventDefault();
    var newText = $(this).data('text');
    $('.logotext-sec p em').fadeOut(200, function(){
      $(this).text(newText).fadeIn(200);
    });
  });



$(".addtocart_imgsec img").click(function(){
  $(this).parents(".card-wrapper").find(".quick-add__submit").trigger("click")
})  

$("img.closebtn").click(function(){
  $(".header__icon--menu").trigger("click");
})


$(".dropdown-mainsec").click(function(){
  if($(this).hasClass("active")){
    $(this).removeClass("active")
  }else{
    $(this).addClass("active")
  }
})



// Result Slider on PDP
$('.result-slidersection').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  infinite: false,
  speed: 600,
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0570/0783/3133/files/Group_1400003720.png?v=1760338938" alt="image" /></button>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1, 
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
   
});



// Custom Variant Box

//var $variantBoxes = $('.variant-box');
$('body').on('click', `.variant-box`, function() { 
  $(this).parents(".card-wrapper").find(".variant-box").removeClass("active");
  $(this).addClass('active');
  var dataPrice = $(this).data("variant-price");  
  var dataComparePrice = $(this).data("variant-compare");  
  var dataDiscount = $(this).data("discount");  
  var dataId = $(this).data("variant-id");  
  $(this).parents(".card-wrapper").find("span.price-item--sale").text(dataPrice);
  $(this).parents(".card-wrapper").find("s.price-item--regular").text(dataComparePrice);
  $(this).parents(".card-wrapper").find(".discount-percentage").text(dataDiscount);
  $(this).parents(".card-wrapper").find(".product-variant-id").val(dataId);
  console.log("dataDiscount", dataDiscount);
 
});

// var $variantBoxes = $('.variant-box')
// $variantBoxes.on('click', function() {
//   $variantBoxes.removeClass('active')
//   $(this).addClass('active')
//   var variantId = $(this).data('variant-id')
//   var price = $(this).data('variant-price')
//   var comparePrice = $(this).data('variant-compare')
//   var productId = $(this).data('pid')
//   var $productCard = $(this).closest('.card-wrapper.product-card-wrapper')
//   $productCard.find('.product-variant-id').val(variantId)
//   var $priceEl = $productCard.find('span.price-item')
//   var $comparePriceEl = $productCard.find('s.price-item.price-item--regular')
//   var $discountEl = $productCard.find('.discount-percentage')
//   console.log("price", price)
//   $priceEl.html(Shopify.Currency.formatMoney(price))
//   if (comparePrice > price) {
//     $comparePriceEl.show().html(Shopify.Currency.formatMoney(comparePrice))
//     var off = Math.round(((comparePrice - price) / comparePrice) * 100)
//     $discountEl.html(off + "% OFF")
//   } else {
//     $comparePriceEl.hide()
//     $discountEl.html("")
//   }
// })





if($(window).width() > 768){
  $('.mobile_price').remove();
}

 
$('body').on('click', '.custom-variantbtn label', function() {
  //debugger;
  var pricetxt = $(this).data("variant-price");
  var comparepricetxt = $(this).data("variant-compare");
  var discount = $(this).data("discount");
  $(".titlecontent-sec span.price-item").text(pricetxt);
  $(".titlecontent-sec s.price-item").text(comparepricetxt);
  $(".titlecontent-sec .discount-percentage").text(discount);
  $(".sticky-atc-btn span").text(pricetxt);
  $(".price-sticky").text(pricetxt);
  $(".compareprice-sticky").text(comparepricetxt);
  $(".savetxt-sticky").text(discount);

})
 


$(".videosec").on("click", function () {
  var $videoBox = $(this);
  var video = $videoBox.find("video").get(0);

 
  if (video.paused) {  
    $(".videosec video").each(function () {
      this.pause();
      $(this).closest(".videosec").removeClass("active");
    });

    video.play();
    $videoBox.addClass("active");
  } 
   
  else {
    video.pause();
    $videoBox.removeClass("active");
  }
});

 
$(".videosec video").on("ended", function () {
  $(this).closest(".videosec").removeClass("active");
}); 


$('.customvideo-box').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '250px',
    arrows: false,
    dots: false,
    infinite: true,
    speed: 600,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '60px'
        }
      }
    ]
  });

}); 


$(window).scroll(function() {
  var scroll = $(window).scrollTop(); // Get current scroll position

  if (scroll >= 500) {
    $(".mobile-related").addClass("sticky"); // Add class if scrolled past 100px
  } else {
    $(".mobile-related").removeClass("sticky"); // Remove class if less than 100px
  }
});


$(".imagesection-grid img").click(function(){
  var dataText = $(this).data("text");
  $(".imagesection-grid img").removeClass("active");
  $(this).addClass("active");
  $("#mainnext").attr("data-value", dataText);

})
  
$("#mainnext").click(function(){
  var dataValue = $(this).attr("data-value"); 
  if(dataValue){
    $(".startmain-section").hide();
    $(`#${dataValue}`).show();
    console.log("dataValue", dataValue);
  }
})

$(".backbtn-same").click(function(){
  $(".startmain-section").show();
  $(".screenfirst-quiz").hide();
})

$("#secondstep-btn").click(function(){
  $("#skinbox").hide();
  $("#skinsecondbox").show();
})
$("#secondbtn-back").click(function(){
  $("#skinbox").show();
  $("#skinsecondbox").hide();
})
$(".imagesec-quiz").click(function(){
  $('.imagesec-quiz').removeClass("active");
  $(this).addClass("active");
})

$("#finalnext-btn").click(function(){
  $("#skinsecondbox").hide();
  $(".collection").show();
  $(".tabbingslider-section").hide();
  $('[data-value="hairsection"]').show();
})

 
$(".videoseccom").on("click", function () {
  var $videoBox = $(this);
  var video = $videoBox.find("video").get(0);

 
  if (video.paused) {  
    $(".videoseccom video").each(function () {
      this.pause();
      $(this).closest(".videoseccom").removeClass("active");
    });

    video.play();
    $videoBox.addClass("active");
  } 
   
  else {
    video.pause();
    $videoBox.removeClass("active");
  }
});

 
$(".videoseccom video").on("ended", function () {
  $(this).closest(".videoseccom").removeClass("active");
}); 